module.exports = __webpack_public_path__ + "img/reset-game.c26f9682.svg";